import { useState } from "react";
import { useStyletron } from "baseui";
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { useCreateTenantMutation } from "../../../services/resourceGroups/tenantApi";

function CreateTenantDialog({ subscriptionId, isOpen, setIsOpen }) {
  const [name, setName] = useState("");
  const [css, theme] = useStyletron();
  const [create, createResult] = useCreateTenantMutation();

  const inputsValid = name !== "";

  function close() {
    setIsOpen(false);
  }

  async function addRg() {
    await create({
      name: name,
      subscriptionId: subscriptionId,
      description: "",
    });
    setIsOpen(false);
  }

  return (
    <>
      <Modal onClose={close} isOpen={isOpen}>
        <ModalHeader>Add new Tenant</ModalHeader>
        <ModalBody>
          <FormControl label={() => "Name"} caption={() => "Enter a descriptive name for the Tenant"}>
            <Input
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
              placeholder="Enter name ..."
              clearable
              clearOnEscape
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <ModalButton kind="tertiary" onClick={close}>
            Cancel
          </ModalButton>
          <ModalButton disabled={!inputsValid} isLoading={createResult.isLoading} onClick={addRg}>
            Okay
          </ModalButton>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default CreateTenantDialog;
